module.exports = __webpack_public_path__ + "static/media/linguagemJavascriptBasicoAvancado.21742bf5.png";